import { DashboardCard } from "@/shared/ui/DashboardCard";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import { topPages } from "../data";

export function TopPages() {
  const { t } = useTranslation();

  return (
    <DashboardCard title={t.analytics.topPages}>
      <div className="space-y-3">
        {topPages.map((page) => (
          <div key={page.path} className="flex items-center justify-between rounded-xl bg-card-muted px-4 py-3">
            <span className="text-sm font-medium text-primary">{page.path}</span>
            <div className="text-right">
              <p className="text-sm font-bold text-foreground">{page.views.toLocaleString()}</p>
              <p className="text-xs text-muted">{t.common.bounce}: {page.bounce}</p>
            </div>
          </div>
        ))}
      </div>
    </DashboardCard>
  );
}
